import React, { Component } from 'react';

// -----------------------------------------------------------------------

// Product download

class ProductDownload extends Component
{
    render()
    {
        let { total, total_selected } = this.props.function_selection_get_product_types();
        
        <button className="popup-button" onClick={() => this.props.function_popup_open('message')}><span>{this.props.function_translate('popup_send_us_a_message')}</span></button>
        
        return (
            <div className="productdownload-container">
                <div className="productdownload-title">
                    {this.props.function_translate('product_download_title')}
                </div>
                <div className="productdownload-button-container">
                    <div className="productdownload-button-relative">
                        <button className="productdownload-button-selection" onClick={() => this.props.function_popup_open('download-all')}>
                            <span>{this.props.function_translate('product_download_all')}</span>
                        </button>
                    </div>

                    <div className="productdownload-button-relative">
                        <button className="productdownload-button-all" onClick={() => this.props.function_popup_open('download-selection')}>
                            <span>{this.props.function_translate('product_download_selection')} ({total_selected})</span>
                        </button>
                    </div>
                </div>
                {this.function_get_selection_product_collection}
            </div>
        );
    }
}

export default ProductDownload